<template>
  <v-container>
    <v-row>
      <v-col class="text-h6 pt-0">
        Create New Alert
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-container>
          <v-row>
            <v-col cols="6" class="text-center">
              <v-btn
                outlined
                color="primary"
                x-large
                @click="handleClickTripwires"
                >Tripwires</v-btn
              >
            </v-col>
            <v-col cols="6" class="text-center">
              <v-btn
                outlined
                color="primary"
                x-large
                :disabled="true"
                @click="handleClickEvents"
                >Events &amp; expert analysis</v-btn
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" class="px-4">
              Setup notifications for Hotspots by location and/or type; and sign
              up to be notified of changes to Pulse, Risk Rating and Evacuation
              indicators.
            </v-col>
            <v-col cols="6" class="px-4">
              Set up notifications for analysis, AI-generated or human-curated
              events, news, social.
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { MODULE_PREFIX_HOME } from "@/store";
import { GET_SELECTOR_PANEL } from "@/store/actions.type";
import {
  EVENT_ACTIONS,
  ALERTSV2_CATEGORIES,
} from "@/common/constants/analytics";

const EMITTED_ACTIONS = {
  CLICK_TRIPWIRES: "click-tripwires",
  CLICK_EVENTS: "click-events",
};

export default {
  name: "NotificationsStepCreateNew",
  methods: {
    handleClickTripwires() {
      this.$emit(EMITTED_ACTIONS.CLICK_TRIPWIRES);
      this.handlePageTrackerEvent(
        ALERTSV2_CATEGORIES.alertsv2,
        EVENT_ACTIONS.clicked,
        "Tripwire Button"
      );
    },
    handleClickEvents() {
      this.$emit(EMITTED_ACTIONS.CLICK_EVENTS);
      const selectorPanel = {};
      selectorPanel.selected = "search";
      selectorPanel.visible = true;
      this.$store.dispatch(
        MODULE_PREFIX_HOME + GET_SELECTOR_PANEL,
        selectorPanel
      );
      this.handlePageTrackerEvent(
        ALERTSV2_CATEGORIES.alertsv2,
        EVENT_ACTIONS.clicked,
        "Events & Expert Analysis Button"
      );
    },
  },
};
</script>

<style scoped></style>
